export const isNullOrUndefined = (value: any) => {
	return value === null || value === undefined;
};
